module.exports = __webpack_public_path__ + "img/map-and-contact-black-all.17a03ca5.png";